// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Carousel.module.scss  */
.Carousel-module-Root_Kld {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  cursor: grab;
  user-select: none;
  transition-timing-function: ease-in-out;
  transition-property: transform;
  will-change: transform;
  touch-action: none; }
  .Carousel-module-Root_Kld:active {
    cursor: grabbing; }

.Carousel-module-Item_3Fb {
  display: flex;
  flex-shrink: 0;
  justify-content: center; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/_internal_/components/Carousel/Carousel.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB,EAAE;EACpB;IACE,gBAAgB,EAAE;;AAEtB;EACE,aAAa;EACb,cAAc;EACd,uBAAuB,EAAE","sourcesContent":["/*  imported from Carousel.module.scss  */\n.Carousel-module-Root_Kld {\n  display: flex;\n  flex-wrap: nowrap;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-left: 0;\n  cursor: grab;\n  user-select: none;\n  transition-timing-function: ease-in-out;\n  transition-property: transform;\n  will-change: transform;\n  touch-action: none; }\n  .Carousel-module-Root_Kld:active {\n    cursor: grabbing; }\n\n.Carousel-module-Item_3Fb {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
